import { render, staticRenderFns } from "./BellQr.vue?vue&type=template&id=34adea05&scoped=true&"
import script from "./BellQr.vue?vue&type=script&lang=js&"
export * from "./BellQr.vue?vue&type=script&lang=js&"
import style0 from "./BellQr.vue?vue&type=style&index=0&id=34adea05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34adea05",
  null
  
)

export default component.exports